module.exports = __webpack_public_path__ + "static/img/hongbao.814edfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hongbao.png
// module id = gQwn
// module chunks = 128